
export class KeyposeCounter {
  public state: number
  public scores: number[]
  public firstUpdate: number
  public lastUpdate: number

  constructor (state: number) {
    this.state = state
    this.scores = []
    this.firstUpdate = 0
    this.lastUpdate = 0
  }

  addScore (score: number): void {
    this.lastUpdate = performance.now()
    if (this.scores.length === 0) {
      this.firstUpdate = this.lastUpdate
    }
    this.scores.push(score)
  }

  averageScore (): number {
    return this.scores.reduce((a, b) => a + b, 0) / this.scores.length
  }

  bestScore (): number {
    return Math.max(...this.scores)
  }
}

export class RepCounter {
  public numPoses: number
  public minDuration: number
  public counters: number[]
  public shouldMirror: boolean
  public allScores: KeyposeCounter[]
  public prevState: number
  public currentState: number
  public stateDuration: number
  public currentScore: KeyposeCounter | null

  constructor (numPoses: number, minDuration = 5) {
    this.numPoses = numPoses
    this.minDuration = minDuration
    this.counters = []
    this.shouldMirror = false
    this.allScores = []
    this.prevState = -1
    this.currentState = -1
    this.stateDuration = 0
    this.currentScore = null
    this.reset()
  }

  reset (): void {
    this.counters = new Array(this.numPoses).fill(0)
    this.allScores = []
    this.prevState = -1
    this.currentState = -1
    this.stateDuration = 0
    this.currentScore = null
  }

  mirror (val: boolean): void {
    this.shouldMirror = val
  }

  private _onStateTransition (state: number): void {
    this.stateDuration = 0
    this.prevState = this.currentState
    this.currentState = state
    this.currentScore = new KeyposeCounter(state)
    this.currentScore.addScore(0)
    this.allScores.push(this.currentScore)
  }

  update (state: number): boolean {
    // transitions must be between valid key poses
    if (state === -1) {
      return false
    }

    let result = false
    if (state !== this.currentState) {
      this._onStateTransition(state)
      result = true
    }

    this.stateDuration++
    if (this.stateDuration === this.minDuration && state < this.counters.length) {
      this.counters[state]++
    }

    return result
  }

  getCount (): number {
    if (!this.counters || this.counters.length < 2) {
      return 0
    }

    // for symmetrical it's probably ok to return the same as dual sided, but trying to count only "full" reps should be the way to go
    return Math.max(0, parseInt(((this.counters[0] + this.counters[this.counters.length - 1] - 1) / 2).toString()))
  }
}
